import React from 'react'
import { Grid,Form } from 'semantic-ui-react'
import CopyLabelWithIcon from '../../../commonComponents/formComponents/copyLabelWithIcon'


const InvoiceBar = ({invoiceNumber,poNo,grossMass,currency,invoiceTotal,netMass,totalItems,totalPackages}) => {
  const style={
    textTransform: 'uppercase',
     marginLeft:'5px',
     color: 'black',
  }
  
  return (
    <Form.Group className='float-container'>
      <Grid className='kn__grid'>
        <Grid.Row>
        <Grid.Column width='3'>
          <p style={style}><strong>Items:&nbsp;</strong><span>{totalItems}</span></p>
        </Grid.Column>
        <Grid.Column width='3'>
        <p style={style}><strong>PKGS:&nbsp;</strong><span>{totalPackages}</span></p>
        </Grid.Column>  
        <Grid.Column width='5' >
        <p style={style}><strong>Gross Mass:&nbsp;</strong><span>{grossMass}</span></p>
        </Grid.Column>
        <Grid.Column width='5' >
        <p style={style}><strong>Net Mass:&nbsp; </strong><span>{netMass}</span></p>
        </Grid.Column>
        </Grid.Row>
        <Grid.Row>
        <Grid.Column width='6'>
        <p style={style}><strong>Value: </strong><span>{currency} &nbsp;{invoiceTotal}</span></p>
        </Grid.Column>
        <Grid.Column width='6'>
        <p style={style}><strong>Invoice No:&nbsp; </strong>
        <CopyLabelWithIcon label={invoiceNumber} fieldInfo={invoiceNumber} />
        </p>
        </Grid.Column>
        <Grid.Column width='4'>
        <p style={style}><strong>PO:&nbsp; </strong><span>{poNo}</span></p>
        </Grid.Column>
        </Grid.Row>

      </Grid>
    </Form.Group>
  )
}

export default InvoiceBar
